import { render } from "./List4.vue?vue&type=template&id=6e0960cf&scoped=true"
import script from "./List4.vue?vue&type=script&lang=js"
export * from "./List4.vue?vue&type=script&lang=js"

import "./List4.vue?vue&type=style&index=0&id=6e0960cf&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0960cf"]])

export default __exports__